const ReactAppStage = process.env.REACT_APP_API_STAGE;
const appClient = process.env.REACT_APP_CLIENT_NAME;

const getApiLink = () => {
  if (appClient == "natanki") {
    if (ReactAppStage == "Live") {
      return "https://api.natanki.com/v1/";
    } else {
      return "https://api.natanki.com/v1/";
    }
  } else if (appClient == "paars") {
    if (ReactAppStage == "Live") {
      return "https://api.paars.in/v1/";
    } else {
      return "https://api.paars.in/v1/";
    }
  } else if (appClient == "fika") {
    if (ReactAppStage == "Live") {
      return "https://api.fikabyshahana.com/v1/";
    } else {
      return "https://api.fikabyshahana.com/v1/";
    }
  } else if (appClient == "oneira") {
    if (ReactAppStage == "Live") {
      return "https://api.oneiradesigns.in/v1/";
    } else {
      return "https://api.oneiradesigns.in/v1/";
    }
  }else if (appClient == "ira") {
    if (ReactAppStage == "Live") {
      return "https://api.iraofficial.com/v1/";
    } else {
      return "https://api.iraofficial.com/v1/";
    }
  }else if (appClient == "kaka") {
    if (ReactAppStage == "Live") {
      return "https://api.kakaaaa.com/v1/";
    } else {
      return "https://api.kakaaaa.com/v1/";
    }
  }else if (appClient == "seraph") {
    if (ReactAppStage == "Live") {
      return "https://api.seraphcollections.in/v1/";
    } else {
      return "https://api.seraphcollections.in/v1/";
    }
  }else if (appClient == "lanzanehub") {
    if (ReactAppStage == "Live") {
      return "https://api.lanzanehub.com/v1/";
    } else {
      return "https://api.lanzanehub.com/v1/";
    }
  } else if (appClient == "Maskhari") {
    if (ReactAppStage == "Live") {
      return "https://api.maskhariworld.com/v1/";
    } else {
      return "https://api.maskhariworld.com/v1/";
    }
  } else if (appClient == "zibacollections") {
    if (ReactAppStage == "Live") {
      return "https://api.zibacollections.com/v1/";
    } else {
      return "https://api.zibacollections.com/v1/";
    }
  } else {
    if (ReactAppStage == "Live") {
      return "https://ecommerce.api.riolabz.com/v1/";
    } else {
      return "https://ecommerce.api.riolabz.com/v1/";
    }
  }
};

const dev = {
  API_ENDPOINT_URL: getApiLink(),
};

const prod = {
  API_ENDPOINT_URL: getApiLink(),
};

const test = {
  API_ENDPOINT_URL: getApiLink(),
};

const getEnv = () => {
  switch (process.env.NODE_ENV) {
    case "development":
      return dev;
    case "production":
      return prod;
    case "test":
      return test;
    default:
      break;
  }
};

export const env = getEnv();
